/*
 * Yoni footer menus. On phones (under 750px) each menu is a <details> closed until tapped; from 750px it
 * is open for good and its heading is plain text (CSS: no pointer, no marker). The markup ships open, so
 * with no script the links are all there; this closes them on a phone and keeps the heading out of the Tab
 * order when it is not a button. The glide of opening and closing is assets/yoni-motion.js, which finds the
 * list through [data-yoni-details]. Crossing 750px (a phone turned on its side) re-sets every menu.
 */
(function () {
  var phone = window.matchMedia('(max-width: 749px)');

  function set(scope) {
    (scope || document).querySelectorAll('details.yoni-footer__col').forEach(function (d) {
      var on = phone.matches;
      d.open = !on;
      d.classList.remove('is-closing');
      var s = d.querySelector(':scope > summary');
      if (!s) return;
      if (on) s.removeAttribute('tabindex'); else s.setAttribute('tabindex', '-1');
    });
  }

  // From 750px the heading is plain text: a screen reader or voice "click" must not close the menu.
  document.addEventListener('click', function (e) {
    if (!phone.matches && e.target.closest && e.target.closest('details.yoni-footer__col > summary')) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  if (phone.addEventListener) phone.addEventListener('change', function () { set(document); });
  set(document);
  // A section re-rendered by the Theme Editor comes back open: set it again.
  document.addEventListener('shopify:section:load', function (e) { set(e.target); });
})();
